import { render, staticRenderFns } from "./RinvPD.vue?vue&type=template&id=33ffd0ba"
import script from "./RinvPD.vue?vue&type=script&lang=js"
export * from "./RinvPD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports